module.exports = __webpack_public_path__ + "static/img/times.a5066f59.png";